import { inject, Injectable } from "@angular/core";
import { map, Observable, shareReplay } from "rxjs";
import { parseToProjectCustomerDocument, ProjectCustomerDocument, ProjectCustomerDocumentDto, ProjectCustomerDocumentId } from "../types/project-customer-document.type";
import { HttpClient, HttpParams, HttpResponse } from "@angular/common/http";
import { ApiCollectionResponse } from "@shared/types/api/api-collection-response";

const DOCUMENT_TYPE_FIELDS: string[] = [ "name", "number", "validityUnit_name", "validityDuration", "defaultDescription" ];
const DOCUMENT_TYPE_PARAMS: HttpParams = new HttpParams()
  .set("fields", DOCUMENT_TYPE_FIELDS.join(","));


interface ProjectCustomerDocumentIdDto {
  readonly typeNumber: string;
}

function parseToDto (value: ProjectCustomerDocumentId): ProjectCustomerDocumentIdDto {
  return {
    typeNumber: value.id
  };
}

@Injectable({
  providedIn: "root"
})
export class ProjectCustomerDocumentService {
  private readonly _httpClient: HttpClient = inject(HttpClient);

  public allDocumentTypes$: Observable<ProjectCustomerDocument[]> = this.fetchData()
    .pipe(
      map((resp: ApiCollectionResponse<ProjectCustomerDocumentDto>) => resp.data
        .map(parseToProjectCustomerDocument)),
      shareReplay({ bufferSize: 1, refCount: true })
    );

  public deleteCustomerDocumentFromProject (projectNumber: string, customerDocumentId: ProjectCustomerDocumentId): Observable<HttpResponse<void>> {
    return this._httpClient[ "delete" ]<undefined>(`api/projects/${ projectNumber }/customer-documents/${ customerDocumentId.id }`, { observe: "response" });
  }

  public addCustomerDocumentToProject (projectNumber: string, customerDocumentId: ProjectCustomerDocumentId): Observable<HttpResponse<void>> {
    const parsedDocument: ProjectCustomerDocumentIdDto = parseToDto(customerDocumentId);

    return this._httpClient.post<undefined>(`api/projects/${ projectNumber }/customer-documents`, parsedDocument, { observe: "response" });
  }

  private fetchData (): Observable<ApiCollectionResponse<ProjectCustomerDocumentDto>> {
    return this._httpClient.get<ApiCollectionResponse<ProjectCustomerDocumentDto>>("api/customers/*/document-types", { params: DOCUMENT_TYPE_PARAMS });
  }
}

